/**
 * Rect math for the onboarding tour's spotlight highlight. Kept as a pure function (no DOM
 * access) so it's unit-testable without mounting the OnboardingTour component — the component
 * calls this with the result of a real getBoundingClientRect().
 */

export interface SpotlightRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

/** Expands `rect` by `padding` px on every side, for drawing the highlight box around it. */
export function computeSpotlightBox(rect: SpotlightRect, padding = 8): SpotlightRect {
  return {
    top: rect.top - padding,
    left: rect.left - padding,
    width: rect.width + padding * 2,
    height: rect.height + padding * 2,
  };
}
